///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { SuiCustomerDTO } from '../../../generated/shared-sui-types.model';
import { CustomerDTO } from '../../../generated/shared-types.model';
import { CustomerDialogComponent } from './customer-dialog.component';

@Component({
    template: '',
    standalone: false
})
export class CreateCustomerDialogWrapperComponent extends AbstractDialogManager<SuiCustomerDTO, CustomerDialogComponent> {
    constructor() {
        super(CustomerDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.payload = new SuiCustomerDTO({} as CustomerDTO);
    }
}
